import { createTheme } from '@mui/material/styles';

export const Colors = {
  blue: '#238AFF',
  black: '#38383B',
  blackAlpha70: '#38383BB2',
  blackAlpha50: '#38383B80',
  blackAlpha30: '#38383B4D',
  gray: '#EEEEEE',
};

export const SECTION_PADDING = {
  py: { xs: '80px', sm: '100px', md: '120px' },
  px: { xs: '24px', sm: '40px', md: '60px' },
};

export const theme = createTheme({
  palette: {
    primary: {
      main: Colors.blue,
      contrastText: '#fff',
    },
    secondary: {
      main: '#B9E2FF',
    },
    background: {
      default: '#ffffff',
    },
    text: {
      primary: Colors.black,
      secondary: Colors.blackAlpha70,
    },
  },
  typography: {
    fontFamily: `'Poppins', 'Helvetica', 'Arial', sans-serif`,
  },
});
